export default "__VITE_ASSET__D9Wq_Jsj__"